// Webpack Imports
import * as bootstrap from 'bootstrap';


( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
} )();


$(document).ready(function(){ 
    $('.project_box').mouseenter( function (){
        $('.visual').removeClass('active');
        var id = $(this).attr('id');
        var key = '#visual_' + id;
        $(key).addClass('active');
    });
    $('.project_box').mouseleave( function (){
        $('.visual').removeClass('active');
    });
    $('.project_box').click( function (){
        var id = $(this).attr('id');
        var key = '#project_' + id;
        $('.project_box').addClass('closed');
        var visual = '#visual_' + id;
        //$(visual).addClass('static');
        $(key).addClass('visible');
        $('.project_panels').show();
        $('.project_buttons').addClass('frozen');
        $('.project_panels').css('scroll-behavior','auto');
        $('.project,.project_panels').scrollTop(0);
        $('.project_panels').css('scroll-behavior','smooth');
    });
    $('.project_panels .back').click( function (){
        $('.project_box').removeClass('closed');
        $('.project').removeClass('visible');
        $('.project_panels').hide();
        $('.visual').removeClass('static');
        $('.project_buttons').removeClass('frozen');
        $('body,html,.project,.project_panels').scrollTop(0);
    });
    $('.minimizer').click( function(){
        let container = $(this).parent();
        let textbox = container.find('.text');
        $(this).toggleClass('open');
        container.toggleClass('full');
        textbox.toggle();
        console.log(container);
    });

    //desktop menu
    $('#yellow_bar li:not(.homelink) .nav-link').click( function(e){
        e.preventDefault();
        var thisItem = $(this).attr('href');

        $('#info,.menu_panel').css('scroll-behavior','auto');
        $('#info,.menu_panel').scrollTop(0);

        $('#info > div').removeClass('open');
        $(thisItem).addClass('open');

        $('#yellow_bar .nav-link').removeClass('active');
        $(this).addClass('active');

        $('main').addClass('frozen');
        $('#yellow_bar').addClass('clicked');
        $('#info').addClass('visible');

        $('#info,.menu_panel').css('scroll-behavior','smooth');
    });
    $('#menu_button').click( function(){
        $('#yellow_bar').removeClass('clicked');
        $('#info').removeClass('visible');
        $('#info > div').removeClass('open');
        $('main').removeClass('frozen');
        $('#yellow_bar .nav-link').removeClass('active');
    });

    //mobile menu
    $('#menu_button_mobile').click( function(){
        $('body,main,.project').toggleClass('frozen_mobile');
        $(".accordion-collapse").removeClass('show');
        $(".accordion-item button").attr('aria-expanded','false');
        $('#yellow_bar').toggleClass('triggered');
        $('#menu_mobile_content').toggleClass('triggered');
    });
    $(".accordion-item button").click( function(){
        $('.accordion_panels').scrollTop(0);
    });
    $('#index_button').click( function(){
        $('body,main,.project').removeClass('frozen_mobile');
        $(".accordion-collapse").removeClass('show');
        $(".accordion-item button").attr('aria-expanded','false');
        $('#yellow_bar').removeClass('triggered');
        $('#menu_mobile_content').removeClass('triggered');
    }); 
});